import React from "react";
import { Hooks } from "@xt/xtbase";
import { navPublicAssetUrl } from "@/utils/navPublicAssetUrl";
import { AUTH_BRAND_POINTS } from "./brandIcons";
import stylesLess from "./index.module.less";

const { FormattedMessage } = Hooks;

/**
 * Stable DOM tree for PC + mobile so auth form children (e.g. Geetest) are not
 * remounted when viewport changes. PC vs mobile chrome is CSS-driven (@media).
 */
export default function AuthShell({ children }) {
  const logoSrc = navPublicAssetUrl("brand/logo-mark.png");

  return (
    <div className={stylesLess.shell}>
      <div className={stylesLess.card}>
        <div className={stylesLess.brandPanel}>
          <div className={stylesLess.brandGlow} aria-hidden />
          <div className={stylesLess.brandInner}>
            <img src={logoSrc} alt="SpikeX" className={stylesLess.logoMark} width={40} height={40} />
            <h2 className={stylesLess.brandTitle}>
              <FormattedMessage id="auth.brandTitle" />
            </h2>
          </div>
          <ul className={stylesLess.brandPoints}>
            {AUTH_BRAND_POINTS.map(({ key, Icon }) => (
              <li key={key} className={stylesLess.brandPoint}>
                <span className={stylesLess.brandPointIcon}>
                  <Icon />
                </span>
                <FormattedMessage id={key} />
              </li>
            ))}
          </ul>
        </div>
        <div className={stylesLess.formPanel}>{children}</div>
      </div>
    </div>
  );
}
